import React from 'react'
import { ToastViewport as ToastViewportOg } from '@mythical/ui'

export const ToastViewport = () => {
  return <ToastViewportOg left={0} right={0} top={10} />
}
